import { render } from "./DocView.vue?vue&type=template&id=796c4c3e"
import script from "./DocView.vue?vue&type=script&lang=js"
export * from "./DocView.vue?vue&type=script&lang=js"

import "./DocView.vue?vue&type=style&index=0&id=796c4c3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__